// Author Lin
// Date 2021-11-15 15:55:19

class MintalMesMstSubstationPoint {
        constructor({
                id = null,
                pointName = '',
                currentTransformerRatio = '',
                potentialTransformerRatio = '',
                magnification = '',
                isActive = '',
                startUsingTime = '',
                initialReading = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.pointName = pointName;
            this.currentTransformerRatio = currentTransformerRatio;
            this.potentialTransformerRatio = potentialTransformerRatio;
            this.magnification = magnification;
            this.isActive = isActive;
            this.startUsingTime = startUsingTime;
            this.initialReading = initialReading;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesMstSubstationPoint();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pointName',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.pointName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'currentTransformerRatio',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.currentTransformerRatio',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'potentialTransformerRatio',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.potentialTransformerRatio',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'magnification',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.magnification',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'isActive',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.isActive',
                sortable: true,
                form: {
                type: 'boolean'
                }
                },
                {
                key: 'startUsingTime',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.startUsingTime',
                sortable: true,
                form: {
                type: 'datetimepicker'
                }
                },
                {
                key: 'initialReading',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.initialReading',
                sortable: true,
                form: {
                type: 'inputNumber'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            pointNameFilter : '',
            currentTransformerRatioFilter : '',
            potentialTransformerRatioFilter : '',
            magnificationFilter : '',
            isActiveFilter : '',
            startUsingTimeFilter : '',
            initialReadingFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'pointNameFilter',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.filter.pointName',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'isActiveFilter',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.filter.isActive',
                disabled: false,
                form: {
                type: 'boolean'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'pointName',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.pointName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                    ,required: true
                        }
                },
                {
                key: 'currentTransformerRatio',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.currentTransformerRatio',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'potentialTransformerRatio',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.potentialTransformerRatio',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'magnification',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.magnification',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                    ,required: true
                        }
                },
                {
                key: 'isActive',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.isActive',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean'
                    ,required: true
                        }
                },
                {
                key: 'startUsingTime',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.startUsingTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'initialReading',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.initialReading',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                    ,required: true
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.mst.mintalMesMstSubstationPoint.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesMstSubstationPoint, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        